module.exports = __webpack_public_path__ + "img/partner_11.56130efc.png";